<template>
    <modal
    name="modal-home-category-service"
    height="auto"
    width="70%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

      <div class="row7">
        <header class="modalHeader flex flexAlignS homeCategoryStepHead">
          <div class="title">
            <div class="flex">
              <p class="step">1단계</p>
              <p class="steptitle mobileReset">고령친화서비스 -  대상자 구분</p>
            </div>
            <p class="mobileBlock steptitleMobile">
              고령친화서비스 -  대상자 구분
            </p>
            <p class="infoTxt">
              대상자를 선택해주세요.
            </p>
          </div>
          <button @click="closed"></button>
        </header>
      </div>

      <div class="homeCategorybody">
        <div class="serviceSelectorCon">
          <button v-for="(target, index) in categoryTargetList" :key="index" @click="goServiceCategoryStep2(target.IDX, target.NAME)">
            <figure>
                <img :src="require('../../assets/images/cmmnMain/CategoryStep/'+target.IMAGE)" v-bind:alt="target.IMAGE">
                <figcaption>{{target.NAME}}</figcaption>
            </figure>
          </button>

          <ModalHomeCategoryServiceStep2 :targetData="targetData" v-if="isShowModalHomeCategoryServiceStep2" @modal-closed='handleModalClosed'/>
        </div>
      </div>
      
      <div class="modalFooterBtn btnBox">
        <button class="redBtn" @click="closed">닫 기</button>
      </div>
      
    </modal>
</template>

<script>
import ModalHomeCategoryServiceStep2 from '@/components/category/ModalHomeCategoryServiceStep2'
import { mapActions } from 'vuex'

export default {
    name: 'ModalHomeCategoryService',
    components: {
        ModalHomeCategoryServiceStep2
    },
    data(){
        return{
            modalResult: false,
            isShowModalHomeCategoryServiceStep2 : false,
            targetData : {
                targetIdx : '',
                targetName : '',
            },
            categoryTargetList : []
        }
    },
    computed:{
    },
    mounted(){
        this.show();

        this.requestTargetList({})
        .then((response) => {
            this.categoryTargetList = response.data;
        })
        .catch(()=>{
            this.$alert('알림', '데이터를 가져올 수 없습니다.')  
        })
    },
    methods:{
        ...mapActions('category', [
            'requestTargetList'
        ]),
        show(){
            this.$modal.show('modal-home-category-service')
        },
        hide(){
            this.$modal.hide('modal-home-category-service')
        },
        beforeOpen(){
        },
        closed(){
            this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
        },
        onClickCancel(){
            this.hide()
        },
        goServiceCategoryStep2(idx, name){
            
            this.targetData.targetIdx = idx;
            this.targetData.targetName = name;

            this.isShowModalHomeCategoryServiceStep2 = true
        },
        handleModalClosed(value){
            if(value === ModalHomeCategoryServiceStep2.name){
                this.isShowModalHomeCategoryServiceStep2 = false
            }
        }
  }
}
</script>